module.exports = __webpack_public_path__ + "img/8.e91532d5.png";